import {
    LogLevel,
    MessageData,
    LogMessageWriter,
} from '@instinet-analytics/core-lib';
import { LogMessagesStoreService } from 'logging/store/LogMessagesStoreService';

export class LogMessagesStoreWriter implements LogMessageWriter {
    public constructor(private store: LogMessagesStoreService) {}

    public writeMessage(
        level: LogLevel,
        source: string,
        message: string,
        data?: MessageData
    ): void {
        this.store.log(level, source, message, data);
    }
}
